import api from "../api/axios";

export const getMyOfficePortals = async () => {
  const response = await api.get("/api/my-office-portals");
  return response.data.portals || [];
};

export const getOfficePortal = async (slug) => {
  const response = await api.get(`/api/office-portal/${slug}`);
  return response.data;
};

export const getOfficePortalProduct = async (slug, productId) => {
  const response = await api.get(
    `/api/office-portal/${slug}/products/${encodeURIComponent(productId)}`,
  );
  return response.data;
};
